import { EventEmitter } from "events";

export class eventEmitterSingleton {
  constructor() {
    this.instance = null;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new EventEmitter();
    }
    return this.instance;
  }
}
